<template>
  <button :class="[$style.button, isFollowed && $style.isFollowed, small && $style.small]" @click="onClick">
    <span v-if="isFollowed"><SvgIcon :svg="HeartFillSvg" :class="$style.heartIcon" />お気に入りに追加済</span>
    <span v-else><SvgIcon :svg="HeartActiveSvg" :class="$style.heartIcon" />お気に入りショップに追加</span>
  </button>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { followMember, unFollowMember } from '@/js/lib/api/member';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import HeartActiveSvg from '@/svgs/vue/heart-active.svg';
import HeartFillSvg from '@/svgs/vue/heart-fill.svg';

const props = defineProps<{
  memberId: number;
  small?: boolean;
}>();
const userStore = useUserStore();
const memberStore = useMemberStore();
const isLoading = ref(false);
const isFollowed = computed(() => memberStore.followedMemberIds.includes(props.memberId));
const follow = async () => {
  memberStore.addFollowedMemberId(props.memberId);
  await followMember({ memberId: props.memberId }).catch(() => {
    memberStore.removeFollowedMemberId(props.memberId);
  });

  window.dataLayer?.push({
    event: 'follow',
    event_category: 'kpi',
    event_label: 'shop',
  });
};
const unfollow = async () => {
  memberStore.removeFollowedMemberId(props.memberId);
  await unFollowMember({ memberId: props.memberId }).catch(() => {
    memberStore.addFollowedMemberId(props.memberId);
  });
};
const onClick = async () => {
  if (userStore.isAuthenticated) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    await (isFollowed.value ? unfollow() : follow());
    isLoading.value = false;
  } else {
    signinSignup({
      next: window.location.href,
      callback: async () => {
        await loading({
          asyncFunc: async () => {
            follow();
            window.location.reload();
          },
          text: 'ログインしています',
        });
      },
    });
  }
};
</script>

<style module lang="scss">
.button {
  background-color: var(--color-white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
  display: block;
  padding: 6px 14px 6px 10px;
  position: relative;
  text-decoration: none;
  width: 100%;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }

  > span {
    align-items: center;
    display: flex;
    justify-content: center;

    .heartIcon {
      fill: var(--color-gray900);
      margin-right: 6px;
      width: 20px;
    }
  }

  &.small {
    border-radius: 0;
    font-size: 12px;
    padding: 5px 8px 5px 4px;

    .heartIcon {
      margin-right: 4px;
    }
  }

  &.isFollowed {
    background-color: var(--action-button-background-color);

    .heartIcon {
      fill: var(--action-button-heart-color);
    }
  }
}
</style>
